import React, { useEffect } from "react";

import { SatisfactionRequest } from "../../../services/userReportServices";

import CommonPopup from "..";
import StarScore from "../../Talk/StarScore";
import CommonButton from "../../Button";
import CommonTextArea from "../../../components/TextArea";

type Props = {
  popup: string;
  setPopup: (popup: string) => void;
  setIsLoading?: (isLoading: boolean) => void;
  open?: (message: string) => void;
  postSatisfaction?: (satisfaction: SatisfactionRequest) => Promise<void>;
  subTitle?: string;
  score?: number;
  content?: string;
};

export default function UserSatisfactionPopup({
  popup,
  setPopup,
  setIsLoading,
  open,
  postSatisfaction,
  subTitle,
  score,
  content,
}: Props) {
  const [satisfactionScore, setSatisfactionScore] = React.useState<number>(
    score ?? 0
  );
  const [satisfactionContent, setSatisfactionContent] = React.useState<string>(
    content ?? ""
  );

  const validation = (error?: boolean) => {
    if (satisfactionScore === 0) {
      if (error) open?.("별점을 선택해주세요.");
      return false;
    }
    return true;
  };

  useEffect(() => {
    setSatisfactionScore(score ?? 0);
    setSatisfactionContent(content ?? "");
  }, [popup]);

  return (
    <CommonPopup
      isOpen={popup === "satisfaction"}
      padding={0}
      title="만족도 평가"
      onClose={() => setPopup("")}
    >
      <div>
        <div className="py-2.5 text-center text-sm text-brand-neutral-90 whitespace-pre-line">
          {subTitle ?? "서비스에 만족하셨나요?\n별점을 남겨주세요"}
        </div>
        <div className="pt-2.5 pb-5 px-5 flex flex-col gap-2.5">
          <div className="flex flex-col items-center py-5">
            <StarScore
              size="L"
              score={satisfactionScore}
              onClick={(score: number) => setSatisfactionScore(score)}
            />
          </div>
          <CommonTextArea
            placeholder="이용 후기를 남겨주세요"
            value={satisfactionContent}
            onChange={(e) =>
              setSatisfactionContent(e.target.value.slice(0, 500))
            }
          />
        </div>
        <CommonButton
          validation={!validation()}
          className="w-full rounded-none h-bottom-button"
          onClick={async () => {
            if (!validation(true)) return;

            setIsLoading?.(true);
            try {
              await postSatisfaction?.({
                satisfaction: satisfactionScore,
                comment: satisfactionContent,
              });
              open?.("만족도 평가가 완료되었습니다.");
              setPopup("");
            } catch (e: any) {
              if (e?.response?.data?.error) {
                open?.(e.response.data.error?.replace(". ", ".\n"));
              } else {
                open?.("만족도 평가 저장에 실패했습니다.");
              }
            } finally {
              setIsLoading?.(false);
            }
          }}
        >
          작성 완료
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
